import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-nested-ternary */
import React, { useMemo, useState, useCallback } from 'react';
import { Table as MuiTable } from '@mui/material';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled, useTheme } from '../styles';
import SortDown from '@pixel/assets/icons/SortDown';
import SortUp from '@pixel/assets/icons/SortUp';
import CustomRow from './CustomRow';
import { CHECKBOX_CELL_WIDTH, COLLAPSE_CELL_WIDTH, generateStickyLeft, stickyLeft, stickyRight, stickyShadowRight, stickyShadowLeft } from './DataTableConstants';
import Typography from '../Typography';
import PixelIconButton from '../PixelIconButton';

// TODO: we may not want to use this, we need to have discussions surrounding how actions are dealt with

// TODO: we may not want to use this, we need to have discussions surrounding how actions are dealt with

// TODO: we may not want to use this, we need to have discussions surrounding how actions are dealt with

// TODO: we may not want to use this, we need to have discussions surrounding how actions are dealt with
// eslint-disable-next-line @typescript-eslint/no-unused-vars

const TableContainerStyled = styled(TableContainer)(_ref => {
  let {
    theme
  } = _ref;
  return {
    overflowX: "auto",
    borderRadius: 8,
    boxShadow: "1px 1px 8px 0px rgba(0, 0, 0, 0.08)"
  };
});
export function DataTable(_ref2) {
  let {
    appliedSortOrder,
    columns,
    labelCheckboxKey,
    labelExpandKey,
    sortOrders,
    results,
    nodeIdKey,
    getRowID,
    onSort,
    renderActions,
    renderExpand,
    renderExpandButton,
    expandButtonPosition = 'left',
    selectable = false,
    selectedIds,
    selectedIdsSet,
    partiallySelectedIds,
    partiallySelectedIdsSet,
    highlightable = false,
    highlightedRowIdSet,
    onSelection,
    onRowClick,
    nodeSelectionIdKey,
    selectionType = 'multiple',
    sx,
    ariaTableLabel,
    labelCheckboxAriaLabel,
    labelCollapseAriaLabel,
    labelExpandAriaLabel,
    labelNoResults,
    stickyAction = true,
    ariaLabelSortButton,
    ariaLabelNoSortsLeftButton,
    ariaLabelDirectionMap,
    verticalAlign = 'middle',
    rowOverflow = true,
    nodeContext
  } = _ref2;
  const theme = useTheme();
  const handleOnSelection = useCallback((node, selected) => {
    if (typeof onSelection === 'function') {
      onSelection(node, selected);
    }
  }, [onSelection]);
  const realSelectedIds = useMemo(() => {
    if (selectedIdsSet) {
      return selectedIdsSet;
    }
    return new Set(selectedIds);
  }, [selectedIds, selectedIdsSet]);
  const realPartiallySelectedIds = useMemo(() => {
    if (partiallySelectedIdsSet) {
      return partiallySelectedIdsSet;
    }
    return new Set(partiallySelectedIds);
  }, [partiallySelectedIds, partiallySelectedIdsSet]);

  // TODO: this needs to change
  const borderBottom = '1px solid #E4EDF3';
  const shouldRenderActions = renderActions && typeof renderActions === 'function';
  const shouldRenderExpand = renderExpand && typeof renderExpand === 'function';
  const stickyLeftWidths = useMemo(() => {
    let initialLeftPosition = 0;
    if (selectable) {
      initialLeftPosition += CHECKBOX_CELL_WIDTH;
    }
    if (shouldRenderExpand) {
      initialLeftPosition += COLLAPSE_CELL_WIDTH;
    }
    return columns.filter(column => column.sticky).map(column => {
      const amountToReturn = initialLeftPosition;
      initialLeftPosition += column.stickyWidth || column.maxWidth || column.minWidth;
      return amountToReturn;
    });
  }, [columns, selectable, shouldRenderExpand, CHECKBOX_CELL_WIDTH, COLLAPSE_CELL_WIDTH]);
  const sortOrderMap = useMemo(() => {
    if (!sortOrders || typeof sortOrders.reduce !== 'function') {
      return {};
    }
    return sortOrders.reduce((acc, sortOrder) => {
      acc[sortOrder.id] = sortOrder;
      return acc;
    }, {});
  }, [sortOrders]);
  return /*#__PURE__*/React.createElement(TableContainerStyled, null, /*#__PURE__*/React.createElement(MuiTable, {
    "aria-label": ariaTableLabel,
    sx: {
      tableLayout: 'auto',
      borderCollapse: 'separate',
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, selectable && /*#__PURE__*/React.createElement(TableCell, {
    variant: "head",
    align: "left",
    size: "small",
    width: CHECKBOX_CELL_WIDTH,
    sx: {
      backgroundColor: theme.palette.background.paper,
      ...stickyLeft,
      boxShadow: stickyShadowLeft,
      borderBottom,
      padding: theme.spacing(1, 1.5)
    }
  }), shouldRenderExpand && expandButtonPosition === 'left' && /*#__PURE__*/React.createElement(TableCell, {
    variant: "head",
    align: "left",
    size: "small",
    width: COLLAPSE_CELL_WIDTH,
    sx: {
      ...generateStickyLeft(selectable ? CHECKBOX_CELL_WIDTH : 0),
      backgroundColor: theme.palette.background.paper,
      boxShadow: stickyShadowLeft,
      padding: theme.spacing(1, 1.5),
      borderBottom
    }
  }), columns.map((column, index) => sortOrderMap[column.id] ? /*#__PURE__*/React.createElement(SortableDataTableHeader, {
    key: column.id,
    column: column,
    borderBottom: borderBottom,
    stickyLeftWidth: stickyLeftWidths[index] || 0,
    sortOrder: sortOrderMap[column.id],
    appliedSortOrder: appliedSortOrder,
    onSort: onSort,
    ariaLabelSortButton: ariaLabelSortButton,
    ariaLabelNoSortsLeftButton: ariaLabelNoSortsLeftButton,
    ariaLabelDirectionMap: ariaLabelDirectionMap
  }) : /*#__PURE__*/React.createElement(SimpleDataTableHeader, {
    key: column.id,
    column: column,
    borderBottom: borderBottom,
    stickyLeftWidth: stickyLeftWidths[index] || 0
  })), shouldRenderExpand && expandButtonPosition === 'right' && /*#__PURE__*/React.createElement(TableCell, {
    variant: "head",
    align: "right",
    size: "small",
    width: COLLAPSE_CELL_WIDTH,
    sx: {
      ...generateStickyLeft(selectable ? CHECKBOX_CELL_WIDTH : 0),
      backgroundColor: theme.palette.background.paper,
      boxShadow: stickyShadowLeft,
      padding: theme.spacing(1, 1.5),
      borderBottom
    }
  }), shouldRenderActions && /*#__PURE__*/React.createElement(TableCell, {
    variant: "head",
    align: "right",
    size: "small",
    sx: {
      borderBottom,
      ...(stickyAction ? {
        boxShadow: stickyShadowRight,
        ...stickyRight
      } : {}),
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(1, 1.5)
    }
  }))), results.nodes.length === 0 && labelNoResults ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TableBody, null), /*#__PURE__*/React.createElement("caption", null, labelNoResults)) : /*#__PURE__*/React.createElement(TableBody, null, results.nodes.map(node => {
    const nodeId = node[nodeIdKey] || getRowID(node);
    const selectionId = node[nodeSelectionIdKey] || nodeId;
    const isHighlighted = highlightedRowIdSet === null || highlightedRowIdSet === void 0 ? void 0 : highlightedRowIdSet.has(nodeId);
    return /*#__PURE__*/React.createElement(CustomRow, {
      id: nodeId,
      key: nodeId,
      nodeData: node,
      columns: columns,
      stickyAction: stickyAction,
      selectable: selectable,
      stickyLeftWidths: stickyLeftWidths,
      isSelected: realSelectedIds.has(selectionId),
      highlightable: highlightable,
      isHighlighted: isHighlighted,
      isPartiallySelected: realPartiallySelectedIds.has(selectionId),
      onSelection: handleOnSelection,
      selectionType: selectionType,
      renderActions: renderActions,
      renderExpand: renderExpand,
      renderExpandButton: renderExpandButton,
      expandButtonPosition: expandButtonPosition,
      labelCollapseAriaLabel: labelCollapseAriaLabel,
      labelExpandAriaLabel: labelExpandAriaLabel,
      labelExpandKey: labelExpandKey,
      labelCheckboxAriaLabel: labelCheckboxAriaLabel,
      labelCheckboxKey: labelCheckboxKey,
      verticalAlign: verticalAlign,
      rowOverflow: rowOverflow,
      nodeContext: nodeContext,
      onClick: onRowClick
    });
  }))));
}
function SimpleDataTableHeader(_ref3) {
  let {
    column,
    borderBottom,
    stickyLeftWidth
  } = _ref3;
  const theme = useTheme();
  return /*#__PURE__*/React.createElement(TableCell, {
    align: "left",
    variant: "head",
    sx: {
      backgroundColor: theme.palette.background.paper,
      borderBottom,
      minWidth: column.sticky ? column.stickyWidth : column.minWidth,
      maxWidth: column.sticky ? column.stickyWidth : column.maxWidth,
      width: column.sticky ? column.stickyWidth : undefined,
      padding: theme.spacing(1, 1.5),
      ...(column.sticky ? {
        boxShadow: stickyShadowLeft,
        ...generateStickyLeft(stickyLeftWidth || 0)
      } : {})
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "overline"
  }, column.columnName)));
}
function SortableDataTableHeader(_ref4) {
  let {
    column,
    borderBottom,
    stickyLeftWidth,
    sortOrder,
    appliedSortOrder,
    onSort,
    ariaLabelSortButton = 'Sort ${column_label} ${direction}',
    ariaLabelNoSortsLeftButton = 'Sorted ${column_label} ${direction}. No other sorts available',
    ariaLabelDirectionMap = {
      asc: 'ascending',
      ascending: 'ascending',
      desc: 'descending',
      descending: 'descending'
    }
  } = _ref4;
  const theme = useTheme();
  const [hovered, setHovered] = useState(false);
  const [currentHovered, setCurrentHovered] = useState(false);
  const nextSortDirection = useMemo(() => {
    if (appliedSortOrder.sortOrder.id === column.id && appliedSortOrder.sortOrder.directions.length > 1) {
      const currentIndex = appliedSortOrder.sortOrder.directions.findIndex(sort => sort === appliedSortOrder.direction);
      if (currentIndex === -1) {
        return false;
      }
      return appliedSortOrder.sortOrder.directions[(currentIndex + 1) % appliedSortOrder.sortOrder.directions.length];
    }
    if (sortOrder) {
      return sortOrder.directions[0];
    }
    return false;
  }, [appliedSortOrder, column, appliedSortOrder.direction]);
  const handleMouseEnter = useCallback(sortOrder ? () => setHovered(true) : undefined, [sortOrder, setHovered]);
  const handleMouseLeave = useCallback(sortOrder ? () => setHovered(false) : undefined, [sortOrder, setHovered]);
  const handleCurrentMouseEnter = useCallback(sortOrder ? () => setCurrentHovered(true) : undefined, [sortOrder, setCurrentHovered]);
  const handleCurrentMouseLeave = useCallback(sortOrder ? () => setCurrentHovered(false) : undefined, [sortOrder, setCurrentHovered]);
  const handleSortChange = useCallback(() => {
    if (typeof onSort === 'function') {
      onSort({
        newSortOrder: {
          sortOrder,
          direction: nextSortDirection
        }
      });
    }
  }, [sortOrder, nextSortDirection, onSort]);
  const currentHeaderSorted = appliedSortOrder.sortOrder.id === column.id;
  const sortHasMoreThanOneDirection = sortOrder.directions.length > 1;
  const nextSortAriaLabel = ariaLabelSortButton.replace('${column_label}', sortOrder.label).replace('${direction}', ariaLabelDirectionMap[nextSortDirection || 'asc']);
  const currentSortAriaLabel = ariaLabelSortButton.replace('${column_label}', sortOrder.label).replace('${direction}', ariaLabelDirectionMap[appliedSortOrder.direction || 'asc']);
  const noSortAriaLabel = ariaLabelNoSortsLeftButton.replace('${column_label}', sortOrder.label).replace('${direction}', ariaLabelDirectionMap[appliedSortOrder.direction || 'asc']);
  return /*#__PURE__*/React.createElement(TableCell, {
    align: "left",
    variant: "head",
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    sx: {
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(1, 1.5),
      borderBottom,
      minWidth: column.sticky ? column.stickyWidth : column.minWidth,
      maxWidth: column.sticky ? column.stickyWidth : column.maxWidth,
      width: column.sticky ? column.stickyWidth : undefined,
      ...(column.sticky ? {
        ...generateStickyLeft(stickyLeftWidth || 0),
        boxShadow: stickyShadowLeft
      } : {})
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "overline"
  }, column.columnName), /*#__PURE__*/React.createElement("div", {
    style: {
      visibility: currentHeaderSorted || hovered ? 'visible' : 'hidden',
      marginLeft: '5px',
      display: 'flex',
      alignItems: 'center'
    }
  }, currentHeaderSorted && sortHasMoreThanOneDirection && nextSortDirection && /*#__PURE__*/React.createElement(PixelIconButton, {
    size: "small",
    onClick: handleSortChange,
    onMouseEnter: handleCurrentMouseEnter,
    onMouseLeave: handleCurrentMouseLeave,
    name: currentHovered ? nextSortAriaLabel : currentSortAriaLabel,
    "aria-label": currentHovered ? nextSortAriaLabel : currentSortAriaLabel
  }, /*#__PURE__*/React.createElement(DataTableSortIcon, {
    direction: currentHovered ? nextSortDirection : appliedSortOrder.direction
  })), !currentHeaderSorted && nextSortDirection && /*#__PURE__*/React.createElement(PixelIconButton, {
    size: "small",
    onClick: handleSortChange,
    onMouseEnter: handleCurrentMouseEnter,
    onMouseLeave: handleCurrentMouseLeave,
    name: nextSortAriaLabel,
    "aria-label": nextSortAriaLabel
  }, /*#__PURE__*/React.createElement(DataTableSortIcon, {
    direction: nextSortDirection
  })), currentHeaderSorted && !sortHasMoreThanOneDirection && /*#__PURE__*/React.createElement(PixelIconButton, {
    size: "small",
    disabled: true,
    onMouseEnter: handleCurrentMouseEnter,
    onMouseLeave: handleCurrentMouseLeave,
    name: noSortAriaLabel,
    "aria-label": noSortAriaLabel
  }, /*#__PURE__*/React.createElement(DataTableSortIcon, {
    direction: appliedSortOrder.direction
  })))));
}
function DataTableSortIcon(_ref5) {
  let {
    direction = 'asc'
  } = _ref5;
  switch (direction) {
    case 'asc':
      return /*#__PURE__*/React.createElement(SortUp, {
        sx: {
          fontSize: '15px'
        }
      });
    case 'desc':
      return /*#__PURE__*/React.createElement(SortDown, {
        sx: {
          fontSize: '15px'
        }
      });
    default:
      return /*#__PURE__*/React.createElement(SortUp, {
        sx: {
          fontSize: '15px'
        }
      });
  }
}
export default DataTable;